"use strict";

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageManager = void 0;

var LocalStorageManager = /*#__PURE__*/_createClass(function LocalStorageManager(handler, saleorState) {
  var _this = this;

  _classCallCheck(this, LocalStorageManager);

  this.getHandler = function () {
    return _this.handler;
  };

  this.addItemToCart = function (variantId, quantity) {
    var _a;

    var lines = ((_a = _this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
    var variantInCheckout = lines.find(function (variant) {
      return variant.variant.id === variantId;
    });
    var alteredLines = lines.filter(function (variant) {
      return variant.variant.id !== variantId;
    });
    var newVariantQuantity = variantInCheckout ? variantInCheckout.quantity + quantity : quantity;

    if (variantInCheckout) {
      variantInCheckout.quantity = newVariantQuantity;
      alteredLines.push(variantInCheckout);
    } else {
      variantInCheckout = {
        quantity: quantity,
        variant: {
          id: variantId
        }
      };
      alteredLines.push(variantInCheckout);
    }

    var alteredCheckout = _this.saleorState.checkout ? Object.assign(Object.assign({}, _this.saleorState.checkout), {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.handler.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.removeItemFromCart = function (variantId) {
    var _a;

    var lines = ((_a = _this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
    var variantInCheckout = lines.find(function (variant) {
      return variant.variant.id === variantId;
    });
    var alteredLines = lines.filter(function (variant) {
      return variant.variant.id !== variantId;
    });

    if (variantInCheckout && _this.saleorState.checkout) {
      variantInCheckout.quantity = 0;
      alteredLines.push(variantInCheckout);
    }

    var alteredCheckout = _this.saleorState.checkout ? Object.assign(Object.assign({}, _this.saleorState.checkout), {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.handler.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.subtractItemFromCart = function (variantId) {
    var _a;

    var lines = ((_a = _this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
    var variantFromCart = lines.find(function (variant) {
      return variant.variant.id === variantId;
    });
    var alteredLines = lines.filter(function (variant) {
      return variant.variant.id !== variantId;
    });
    var newVariantQuantity = variantFromCart ? variantFromCart.quantity - 1 : 0;

    if (variantFromCart) {
      variantFromCart.quantity = newVariantQuantity;
      alteredLines.push(variantFromCart);
    }

    var alteredCheckout = _this.saleorState.checkout ? Object.assign(Object.assign({}, _this.saleorState.checkout), {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.handler.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.updateItemInCart = function (variantId, quantity) {
    var _a;

    var lines = ((_a = _this.saleorState.checkout) === null || _a === void 0 ? void 0 : _a.lines) || [];
    var variantInCheckout = lines.find(function (variant) {
      return variant.variant.id === variantId;
    });
    var alteredLines = lines.filter(function (variant) {
      return variant.variant.id !== variantId;
    });

    if (variantInCheckout) {
      variantInCheckout.quantity = quantity;
      alteredLines.push(variantInCheckout);
    }

    var alteredCheckout = _this.saleorState.checkout ? Object.assign(Object.assign({}, _this.saleorState.checkout), {
      lines: alteredLines
    }) : {
      lines: alteredLines
    };

    _this.handler.setCheckout(alteredCheckout);

    return alteredCheckout;
  };

  this.handler = handler;
  this.saleorState = saleorState;
});

exports.LocalStorageManager = LocalStorageManager;